module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0093.jpg?v=10117791";